/**
 * Auth provider switch (FE-301).
 *
 * `legacy` keeps the wallet-challenge flow (Phantom signature →
 * `verifyWalletSignature`). `privy` mounts the Privy SDK: Privy handles
 * identity (email OTP, Google, Apple, external Solana wallets) and the
 * embedded Solana wallet, and the frontend exchanges Privy tokens for the
 * XYRO cookie session through `signInPrivy`.
 *
 * The flag stays until the migration (BE-302) is done; then `legacy` and the
 * old auth wizard go away.
 */
export enum AuthProvider {
  legacy = 'legacy',
  privy = 'privy'
}

const readAuthProvider = (): AuthProvider =>
  import.meta.env.VITE_AUTH_PROVIDER === AuthProvider.privy ?
    AuthProvider.privy
  : AuthProvider.legacy

export const AUTH_PROVIDER = readAuthProvider()

export const IS_PRIVY_AUTH = AUTH_PROVIDER === AuthProvider.privy

/** Public app id from the Privy dashboard; safe to ship in the bundle. */
export const PRIVY_APP_ID: string = import.meta.env.VITE_PRIVY_APP_ID ?? ''

/** Optional app client id (per-environment Privy settings). */
export const PRIVY_CLIENT_ID: string | undefined =
  import.meta.env.VITE_PRIVY_CLIENT_ID || undefined

/** Reown (WalletConnect Cloud) project id; enables the QR wallet option. */
export const WALLETCONNECT_PROJECT_ID: string | undefined =
  import.meta.env.VITE_WALLETCONNECT_PROJECT_ID || undefined
